/**
 * Created by mcochrane on 1/10/17.
 */

export function mapNewToOldIndex (newIndex, diffs) {
  let offset = 0
  let isInAddition = false

  diffs.diffs.every((diff) => {
    if (diff.length > 0) {
      if (newIndex >= diff.newIndex && newIndex < diff.newIndex + diff.length) {
        isInAddition = true
        return false
      }
    }
    if (diff.newIndex > newIndex) return false
    // if it's a replacement, don't change the offset
    if (diff.hasOwnProperty('add') && diff.hasOwnProperty('del')) return true
    offset += diff.length
    return true
  })

  let oldIndex = newIndex - offset

  if (isInAddition) return null
  if (oldIndex < 0 || oldIndex >= diffs.oldStr.length) return null

  return oldIndex
}

function newDiff () {
  return {
    oldIndex: 0,
    newIndex: 0,
    length: 0
    // add: '',    // Text that is inserted
    // del: ''     // Text that is deleted
  }
}

/**
 * Returns the differences between two strings.
 * @param oldStr the old string
 * @param newStr the new string
 * @returns {{oldStr: *, newStr: *, diffs: Array}}
 */
export function stringdiff (oldStr, newStr) {
  const maxLen = Math.max(oldStr.length, newStr.length)

  // Offset in newStr
  let offset = 0

  const diffs = []
  let diff = null

  let i = 0
  while (Math.min(i, i + offset) < maxLen) {
    if (diff === null) {
      // console.log('oldStr[i] (' + oldStr[i] +') !== newStr[i+offset] (' + newStr[i+offset] + ')');
      if (oldStr[i] !== newStr[i + offset]) {
        diff = newDiff()
        diff.oldIndex = i
        diff.newIndex = i + offset
        diff.length = 1
        // console.log('startDiff:' + i + ":" + (i+offset));
      }
    } else {
      // console.log('oldStr[diff.oldIndex] (' + oldStr[diff.oldIndex] +') === newStr[diff.newIndex+diff.length] (' + newStr[diff.newIndex+diff.length] + ')');
      // console.log('newStr[diff.newIndex] (' + newStr[diff.newIndex] +') === oldStr[diff.oldIndex+diff.length] (' + oldStr[diff.oldIndex+diff.length] + ')');
      if (oldStr[diff.oldIndex + diff.length] === newStr[diff.newIndex + diff.length]) {
        if (typeof oldStr[diff.oldIndex + diff.length] === 'undefined') break
        // replaced a section!

        diff.del = oldStr.substr(diff.oldIndex, diff.length)
        diff.add = newStr.substr(diff.newIndex, diff.length)
        diffs.push(diff)
        // console.log('addDiff:');
        // console.log(diff);

        diff = null
      } else if (oldStr[diff.oldIndex] === newStr[diff.newIndex + diff.length]) {
        // ie hold oldStr position constant and see if we get a match moving newStr pos forward
        // Here we have a match.  Str2 is ahead of oldStr so this is an insertion
        diff.add = newStr.substr(diff.newIndex, diff.length)
        offset += diff.length
        // console.log('addDiff:');
        // console.log(diff);
        diffs.push(diff)
        diff = null
      } else if (newStr[diff.newIndex] === oldStr[diff.oldIndex + diff.length]) {
        // ie hold newStr position constant and see if we get a match moving oldStr pos forward
        // Here we have a match.  Str1 is ahead of newStr so this is a deletion
        diff.del = oldStr.substr(diff.oldIndex, diff.length)
        diff.length = -diff.length // negate length
        offset += diff.length
        // console.log('addDiff:');
        // console.log(diff);
        diffs.push(diff)
        diff = null
      } else {
        diff.length++
      }
    }
    i++
  }

  if (diff !== null) {
    if (diff.oldIndex + diff.length === oldStr.length && diff.newIndex + diff.length === newStr.length) {
      // Replaced section

      diff.del = oldStr.substr(diff.oldIndex, diff.length)
      diff.add = newStr.substr(diff.newIndex, diff.length)
      diffs.push(diff)
    } else if (diff.oldIndex + diff.length > oldStr.length) {
      // Has to be an insertion!
      diff.add = newStr.substr(diff.newIndex, diff.length)
      diffs.push(diff)
    } else {
      // It's a deletion
      diff.del = oldStr.substr(diff.oldIndex, diff.length)
      diff.length = -diff.length // negate length
      diffs.push(diff)
    }

    diff = null
  }

  return { oldStr: oldStr, newStr: newStr, diffs: diffs }
}

// export default function stringdiff(str1, str2) {
//     var maxLen = Math.max(str1.length, str2.length);
//     var minLen = Math.min(str1.length, str2.length);
//
//     // Offset in string 2
//     var offset = 0;
//
//     var diffs = [];
//     var diff = null;
//
//     var i = 0;
//     var cnt = 0;
//     while (cnt < maxLen) {
//         // console.log(i);
//         // Current index in str2
//         let i2 = i+offset;
//         if (str1[i] === str2[i2]) {
//             if (diff !== null) {
//                 diffs.push(diff);
//                 diff = null;
//             }
//             i++;
//         } else {
//             if (diff === null) {
//                 diff = newDiff();
//                 diff.oldIndex = i;
//                 diff.newIndex = i2;
//                 diff.length = 1;
//                 diff.diff = str2[i2];
//             } else {
//                 diff.length++;
//                 diff.diff += str2[i2];
//             }
//             offset++;
//         }
//         cnt++;
//     }
//
//     if (diff !== null) diffs.push(diff);
//
//     return diffs;
// }
